const WORDS = ['React.js','Node.js','MongoDB','Next.js','TypeScript','AWS','DigitalOcean','Docker','WordPress','UI/UX','Full-Stack','IoT','IBM Maximo'];
export default function Marquee() {
  const doubled = [...WORDS,...WORDS];
  return (
    <div className="mstrip">
      <div className="mtrack">
        {doubled.map((w,i) => (
          <div key={i} className="mi"><span className="md"/>{w}</div>
        ))}
      </div>
    </div>
  );
}
